import React, { memo, useEffect } from 'react';
import { connect } from 'react-redux';
import { projectFormStep } from '@model';
import FirstStep from './projectsDetailForm';
import SecondStep from './teamDetailFrom';
import ThirdStep from './clientDetailForm';
import FourthStep from './groupsDetailForm';
// import FifthStep from './moduleSetting';
import FifthStep from './moduleDetailForm';
import Result from './createResult';
import { useHistory } from 'react-router-dom';
import action from '@flux/action';
// import '@style/modules/project/projectsForm.scss';
// import '@style/modules/project/m365.scss';
import '../../../styles/modules/project/projectsForm.scss';
import '../../../styles/modules/project/m365.scss';
import alert from '@components/alert';
// import { testLog } from '@utils/logEnhance';
import { getSessionStorage } from '@utils/windowUtil';

const projectFormStepFormatData = projectFormStep.reduce(
  (result, item) => {
    const { path, label } = result;
    return {
      path: [...path, item.path],
      label: [...label, item.label],
    };
  },
  { path: [], label: [] },
);

const SkippableNote = ({ configType }) => (
  <div className="skippable-note">
    <b>Note:</b> You can skip {configType} configuration and input information
    later.
  </div>
);

const [
  FIRST_STEP,
  SECOND_STEP,
  THIRD_STEP,
  FOURTH_STEP,
  FIFTH_STEP,
  LAST_STEP,
] = projectFormStepFormatData.path;

const Title = ({ success, currentStep }) => {
  if (success && currentStep === 6) {
    return (
      <h1 className="project-form-title">
        ‘{getSessionStorage('newProjectName') || 'project'}’ initiated
      </h1>
    );
  }
  return <h1 className="project-form-title">Create a New Project</h1>;
};

function ProjectDetailsForm(props) {
  const {
    match: {
      params: { step },
    },
    saveTeamsNames,
    changeTeamsDetail,
    saveData,
    projects,
    changeTeamsNames,
    clearTeamsData,
    clearGroupData,
    saveCreateProjectData,
    hideShowProjectDetail,
  } = props;
  const history = useHistory();
  // 调试create project快捷点直接在这设置默认tab就行了
  const currentStep = saveData.currentStep;

  useEffect(
    () => () => {
      clearTeamsData();
      clearGroupData();
      saveCreateProjectData({ init: true });
    },
    [],
  );
  useEffect(() => {
    changeTeamsNames({ data: [] });
    return () => {
      saveTeamsNames({ data: [], memberData: [] });
      changeTeamsDetail(null);
    };
  }, [changeTeamsDetail]);
  // 这是自定义的Steps组件 --开始
  const Steps = ({ data = [], step = 0, isEditing = false }) => {
    const iconName = (key) =>
      key <= step ? 'individualIconFinished' : 'individualIconUnfinish';
    return (
      <div className="stepsBox">
        {Array.isArray(data) &&
          data.map((item, key) => (
            <div className="stepBox" key={key}>
              {isEditing && key + 1 === step ? (
                <span className="individualIconFinishing" />
              ) : (
                <span className={iconName(key + 1)} />
              )}
              <span className="progressStyle" />
              <span className="explainText">{item}</span>
            </div>
          ))}
      </div>
    );
  };
  // 这是自定((义的Steps组件 --结束

  const mapStepToNum = (_step) =>
    projectFormStepFormatData.path.indexOf(_step) + 1;

  // useEffect(() => {
  //   let report = ['current step: ', currentStep, '\nproject data', projects];
  //   testLog(report);
  // }, [currentStep]);

  return (
    <div className="projects-create-page-wrapper alter-error-color">
      <div className="content-container" style={{ position: 'relative' }}>
        <span
          className="dd-back-btn"
          style={{ display: step === LAST_STEP ? 'none' : 'inline-block' }}
          onClick={() => {
            alert.confirm({
              onOk: () => {
                hideShowProjectDetail();
                history.push('/projects/list');
              },
              okText: 'yes',
              cancelText: 'no',
              cancelButtonProps: { className: 'fill-btn' },
              okButtonProps: { className: 'outline-btn' },
              content: 'Are you sure you want to cancel project creation?',
            });
          }}
        >
          <span className="appkiticon icon-left-chevron-fill a-font-12" />{' '}
          Cancel Project Creation
        </span>
        <Title
          success={step === LAST_STEP}
          currentStep={saveData.currentStep}
        />

        <div className="project-form-step-wrapper">
          <Steps
            data={projectFormStepFormatData.label}
            step={saveData.currentStep}
            isEditing={saveData.isEditing}
          />
        </div>

        <div className="project-form-divider" />

        {currentStep === 1 && (
          <FirstStep steps={SECOND_STEP} tranStep={mapStepToNum} />
        )}
        {currentStep === 2 && (
          <SecondStep
            steps={[FIRST_STEP, THIRD_STEP]}
            tranStep={mapStepToNum}
          />
        )}
        {currentStep === 3 && (
          <ThirdStep
            steps={[SECOND_STEP, FOURTH_STEP]}
            tranStep={mapStepToNum}
          />
        )}
        {currentStep === 4 && (
          <>
            <SkippableNote configType="Group" />
            <FourthStep
              steps={[THIRD_STEP, FIFTH_STEP]}
              tranStep={mapStepToNum}
            />
          </>
        )}
        {currentStep === 5 && (
          <>
            <SkippableNote configType="Module" />
            <FifthStep
              steps={[FOURTH_STEP, LAST_STEP]}
              tranStep={mapStepToNum}
            />
          </>
        )}
        {currentStep === 6 && <Result />}
      </div>
    </div>
  );
}

const mapStateToProps = ({ projects }) => ({
  saveData: projects.saveData,
  projects,
});

const mapDispatchToProps = (dispatch) => ({
  saveTeamsNames(data) {
    dispatch(action.saveTeamsNames(data));
  },
  changeTeamsNames(data) {
    dispatch(action.changeTeamsNames(data));
  },
  changeTeamsDetail(data) {
    dispatch(action.changeTeamsDetail(data));
  },
  clearTeamsData() {
    dispatch(action.clearTeamsData());
  },
  clearGroupData() {
    dispatch(action.changeGroupsDetail([]));
  },
  saveCreateProjectData(data) {
    dispatch(action.saveData(data));
  },
  hideShowProjectDetail() {
    dispatch(action.changeUserPreference({ shouldShowDetail: false }));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(ProjectDetailsForm));
